import { BoxProps, Stack, StackProps, VStack } from '@chakra-ui/react'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'

export interface SectionWrapperProps extends StackProps {
  children: React.ReactNode
  bgColor?: string
  bgGradient?: string
  boxShadow?: string
  removeBottomPadding?: boolean
  gap?: StackProps['gap']
  paddingY?: BoxProps['paddingY']
  paddingX?: BoxProps['paddingX']
  maxWidth?: BoxProps['maxWidth']
  id?: string
  stackProps?: StackProps
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({
  children,
  bgColor,
  bgGradient,
  boxShadow,
  removeBottomPadding,
  gap,
  paddingX,
  paddingY,
  maxWidth,
  id,
  stackProps,
  ...props
}) => {
  const { getBreakpointValue } = useBreakpointContext()

  return (
    <VStack
      bg={bgGradient}
      bgColor={bgColor}
      boxShadow={boxShadow}
      id={id}
      paddingBottom={removeBottomPadding ? 0 : (paddingY ?? getBreakpointValue([10, 20]))}
      paddingX={paddingX ?? getBreakpointValue([2, 2, 4, 6, 8])}
      paddingY={paddingY ?? getBreakpointValue([6, 6, 8, 10, 16])}
      position={'relative'}
      width={'full'}
      {...stackProps}
    >
      <Stack
        align={'center'}
        borderRadius={'3xl'}
        gap={gap ?? 10}
        maxWidth={maxWidth ?? '80em'}
        width={'full'}
        {...props}
      >
        {children}
      </Stack>
    </VStack>
  )
}

export default SectionWrapper
